export default function handleProjectTeaserFull() {

    const projectTeaserFullImgs = document.querySelectorAll('.project-teaser-full__img');

    if (!projectTeaserFullImgs) return;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            } else {
                entry.target.classList.remove('is-visible');
            }
        });
    }, {
        root: null,
        rootMargin: '-100px',
        threshold: [0, 1]
    });

    projectTeaserFullImgs.forEach(element => {
        observer.observe(element);
    });

}
